var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.953,
    height: 17,
    viewBox: "0 0 18.953 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .mess-cls-1, .mess-cls-2 {\n        fill: none;\n        stroke: #a7a7be;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.2px;\n      }\n\n      .mess-cls-2 {\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Message",
    transform: "translate(0.6 0.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    className: "mess-cls-1",
    d: "M16.4,9.061l-3.937,3.17a2.052,2.052,0,0,1-2.535,0L5.954,9.061",
    transform: "translate(-2.304 -3.928)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    className: "mess-cls-2",
    d: "M6.512,3.5h8.7a4.576,4.576,0,0,1,3.3,1.468,4.631,4.631,0,0,1,1.224,3.419v6.026a4.631,4.631,0,0,1-1.224,3.419,4.576,4.576,0,0,1-3.3,1.468h-8.7A4.586,4.586,0,0,1,2,14.413V8.387A4.586,4.586,0,0,1,6.512,3.5Z",
    transform: "translate(-2 -3.5)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.85e60629.svg";
export { ForwardRef as ReactComponent };